import { useEffect, useRef } from 'react'

export function useFireOnce(fire: () => void): void {
  const firedRef = useRef(false)
  useEffect(() => {
    if (firedRef.current) return
    firedRef.current = true
    fire()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
